module.exports = __webpack_public_path__ + "static/top-70cff3dae7f2995fc3aa154a320447d3.png";